
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"64","viewBox":"0 0 26 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.459 52.826v7.553a2.756 2.756 0 01-2.757 2.756H3.644A2.756 2.756 0 01.888 60.38V49.113s-.646-15.96 4.417-23.709c3.459-5.362 4.359-9.225 4.359-13.838V6.1M24.47 46.772v1.626M15.683 6.1v5.49c0 4.612.865 8.452 4.359 13.837 2.848 4.394 3.897 11.37 4.255 16.617","stroke":"#B69E64","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.879.865H9.502a.819.819 0 00-.819.819V5.28c0 .453.367.82.82.82h6.376a.819.819 0 00.819-.82V1.684a.819.819 0 00-.819-.82z","stroke":"#1D1D1B","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.809 26.234l7.08 7.08a1.05 1.05 0 001.453 0l7.138-7.08","stroke":"#B69E64","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.373 42.02H5.927v16.145h13.446V42.021zM12.65 26.177v-9.33M12.696 13.838v-1.672M9.721 51.915h5.743M9.721 54.66h5.743","stroke":"#1D1D1B","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    